import { Fikogram } from "./IFikoThreeJS/FikoThreeCam/Fikogram";
import { FikoOperasyon } from "./IFikoThreeJS/FikoThreeCam/Fikoperasyon";
import { FikoOperasyonlar } from "./IFikoThreeJS/FikoThreeCam/Fikoperasyonlar";
import { FikoCizimler } from "./IFikoThreeJS/FikoThreeCam/FikoCizimler";
import { FikoEksen } from "./IFikoThreeJS/FikoEksen";
import { FikoSahne } from "./IFikoThreeJS/FikoSahne";
import { FikoApt } from "./IFikoThreeJS/FikoThreeCam/FikoApt";
import { FikoCizimWRL } from "./IFikoThreeJS/FikoThreeCam/FikoCizimWRL";
import { FikoGrup } from "./IFikoThreeJS/FikoGrup";
import { FikoGrupCizim } from "./IFikoThreeJS/FikoGrupCizim";
import { FikoCizimYalin } from "./IFikoThreeJS/FikoCizimYalin";
import { FikoArrowYardimci } from "./IFikoThreeJS/FikoArrowYardimci";
import { Fikogramlar } from "./IFikoThreeJS/FikoThreeCam/Fikogramlar";
import { FikoAPTCAT } from "./IFikoThreeJS/FikoThreeCam/FikoAPTCAD";
import { FikoTakimYolu } from "./IFikoThreeJS/FikoThreeCam/FikoTakimYolu";
import { FikoVektorTakimYol3D } from "./IFikoThreeJS/FikoThreeCam/FikoVektorTakimYol3d";
import { FikoKonum, FikoKonumlar } from "./IFikoThreeJS/FikoKonumlar/FikoKonumlar";
import { FikoKaynakca } from "./IFikoThreeJS/FikoThreeCam/FikoKaynakca";
import { Fiko3DIsaretleyiciler } from "./IFikoThreeJS/Fiko3DIsaretleyiciler";
import { Fiko3DYaziIsaretleyici } from "./IFikoThreeJS/Fiko3DYaziIsaretleyici";
import { FikoCamAktivite, FikoCamTakimNode } from "./IFikoThreeJS/fiko-cam/fiko-cam-aktivite";

export const Siniflar: any = {
    FikoCamAktivite,
    FikoCamTakimNode,
    FikoOperasyonlar: FikoOperasyonlar,
    FikoCizimler,
    Fikoperasyon: FikoOperasyon,
    Fikogramlar,
    Fikogram,
    FikoEksen,
    FikoArrowYardimci,
    FikoApt,
    FikoCizimWRL,
    FikoGrup,
    FikoGrupCizim,
    FikoCizimYalin,
    FikoAPTCAT,
    FikoTakimYolu,
    FikoVektorTakimYol3D,
    FikoKaynakca,
    FikoKonumlar,
    Fiko3DIsaretleyiciler,
    Fiko3DIsaretleyici: Fiko3DYaziIsaretleyici, // type uyumu için
    // FikoKonum,
}

export const sinifAl = (sinif: string) => {
    if (!sinif || Siniflar[sinif] === undefined || Siniflar[sinif] === null) {
        throw new Error(`'${sinif}\' FikoGL Sistemine Tanıtılmamış`);
    }
    return Siniflar[sinif];
}

export const jsondan = (sahne?: FikoSahne, parent?: any, json?: any, binBuffers?: Uint8Array[]): any => {
    if (!json || !json.type || !Siniflar[json.type]) {
        console.warn(`[FikoThreeType] Atlandı: '${json?.type}' tipi kayıtlı değil veya fromJson desteklemiyor`);
        return null;
    }
    const _sinif = Siniflar[json.type];
    if (!_sinif.fromJson) {
        console.warn(`[FikoThreeType] '${json.type}' sınıfı fromJson desteklemiyor, atlanıyor`);
        return null;
    }
    return _sinif.fromJson(sahne, parent, json, binBuffers);
}
